// @flow
import { IconVideoQualityAudioOnly, IconVideoQualityHD, IconVideoQualityLD, IconVideoQualitySD } from '../../base/icons/svg/index';
// import { connect } from '../../base/redux';
import { connect } from 'react-redux';
import { openDialog } from '../../base/dialog/actions';
import { VIDEO_QUALITY_LEVELS } from '../constants';
import { findNearestQualityLevel } from '../functions';
/**
 * A map of of selectable receive resolutions to corresponding icons.
 *
 * @private
 * @type {Object}
 */
const VIDEO_QUALITY_TO_ICON = {
    [VIDEO_QUALITY_LEVELS.ULTRA]: IconVideoQualityHD,
    [VIDEO_QUALITY_LEVELS.HIGH]: IconVideoQualityHD,
    [VIDEO_QUALITY_LEVELS.STANDARD]: IconVideoQualitySD,
    [VIDEO_QUALITY_LEVELS.LOW]: IconVideoQualityLD
};
import { translate } from '../../base/i18n/functions';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
// import {
//     AbstractButton,
//     Props as AbstractButtonProps
// } from '../../base/toolbox/components/AbstractButton';
import VideoQualityDialog from './VideoQualityDialog.web';
// const dispatch = useDispatch();
/**
 * React {@code Component} responsible for displaying a button in the overflow
 * menu of the toolbar, including an icon showing the currently selected
 * max receive quality.
 *
 * @augments Component
 */
class VideoQualityButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.callQuality';
    label = 'toolbar.accessibilityLabel.callQuality';
    tooltip = 'toolbar.accessibilityLabel.callQuality';
    /**
     * Dynamically retrieves the icon.
     */
    // @ts-ignore
    get icon() {
        const { _audioOnly, _videoQuality } = this.props;
        const videoQualityLevel = findNearestQualityLevel(_videoQuality);
        const icon = _audioOnly || !videoQualityLevel ? IconVideoQualityAudioOnly : VIDEO_QUALITY_TO_ICON[videoQualityLevel];
        return icon;
    }
    /**
     * Required by linter due to AbstractButton overwritten prop being writable.
     *
     * @param {string} value - The icon value.
     */
    set icon(value) {
        // @ts-ignore
        return value;
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { handleClick } = this.props;
        // class VideoQualityButton extends AbstractButton<IProps> {
        //     override accessibilityLabel = 'toolbar.accessibilityLabel.callQuality';
        //     override label = 'videoStatus.performanceSettings';
        //     override tooltip = 'videoStatus.performanceSettings';
        //     override icon = IconPerformance;
        //     /**
        //     * Handles clicking the button, and opens the video quality dialog.
        //     *
        //     * @private
        //     * @returns {void}
        //     */
        //     override _handleClick() {
        //         const { dispatch } = this.props;
        if (handleClick) {
            handleClick();
            // dispatch(
            openDialog('VideoQualityDialog', VideoQualityDialog);
            // );
        }
    }
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code VideoQualityButton} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _audioOnly: boolean,
 *     _videoQuality: number
 * }}
 */
function _mapStateToProps(state) {
    return {
        _audioOnly: state['features/base/audio-only'].enabled,
        _videoQuality: state['features/video-quality'].preferredVideoQuality
    };
}
export default translate(connect(_mapStateToProps)(VideoQualityButton));
// icon = IconPerformance;
/**
 * Handles clicking the button, and opens the video quality dialog.
 *
 * @private
 * @returns {void}
 */
// _handleClick() {
//     const { dispatch } = this.props;
//
//     sendAnalytics(createToolbarEvent('video.quality'));
//
//     dispatch(openDialog(VideoQualityDialog));
// }
// }
// export default connect()(translate(VideoQualityButton));
